import { AbstractControl, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
   return (control: AbstractControl) => {
      if (!control.value) {
         return null;
      }
      const digitsOnly = control.value?.replace(/[\s().-]/g, '');
      const isValid = /^\s*[2-9][0-9]\d[2-9]\d{6}\s*$/.test(digitsOnly);

      return isValid ? null : { pattern: true };
   };
}

export function americanOrInternationalPhoneNumberValidator(): ValidatorFn {
   return (control: AbstractControl) => {
      if (!control.value) {
         return null;
      }
      const digitsOnly = control.value?.replace(/[\s().-]/g, '');
      const isValid = /^\s*(?:[2-9][0-9]\d[2-9]\d{6}|[1-9]\d{7,14})\s*$/.test(digitsOnly);

      return isValid ? null : { pattern: true };
   };
}
